"use client";

import React from "react";

const HistoricalContext: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Historical Context: Origins of Dental Sealants
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        The concept of dental sealants has been around for quite some time, with
        the first patent for a sealant-like material being filed in 1936. However,
        it wasn&#39;t until the 1950s and 1960s that scientists began experimenting
        with different materials to create effective sealants.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        Early dental sealants were made from various substances, including
        mercury-based compounds and other amalgam fillings. But as research
        progressed, dentists sought out safer, more durable alternatives. In the
        1980s, a significant breakthrough occurred with the development of
        resin-based sealants – the same type used today.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        These modern dental sealants are made from a combination of Bisphenol A
        glycidyl methacrylate (Bis-GMA), triethylene glycol dimethacrylate
        (TEGDMA), and other components. This innovative material offers superior
        durability, adhesion, and resistance to wear and tear compared to its
        predecessors. As a result, resin-based dental sealants have become the gold
        standard for preventing tooth decay in both children and adults.
      </p>
    </div>
  );
};

export default HistoricalContext;